export default function Index(){
    return(
        <div>
            About
        </div>
    )
}